import { DayValue } from "@amir04lm26/react-modern-calendar-date-picker";
import moment from 'moment';

type DateFormat = 'iso' | 'isoDateTime' | 'time' | 'hour';
export type NotificationGroup = 'Today' | 'Yesterday' | 'Last Week' | 'Older';

export const notificationGroups: NotificationGroup[] = ['Today', 'Yesterday', 'Last Week', 'Older'];

const dateFormats = {
    time: 'LT',
    hour: 'HH',
    iso: 'MM-DD-YYYY',
    isoDateTime: 'MM-DD-YYYYTHH:mm:ss',
};

export function formatDate(date: Date | string, format: DateFormat = 'iso') {
    return moment(date).format(dateFormats[format]);
};

export function fromDatePickerFormat(date: DayValue): string {
    if (!date) return '';
    return `${date.month < 10 ? `0${date.month}` : date.month}-${date.day < 10 ? `0${date.day}` : date.day}-${date?.year}`;
};

export function toDatePickerFormat(date: string | null): DayValue {
    let output = null;

    if (typeof date === 'string' && date !== '') {

        output = {
            day: Number(date?.slice(3, 5)),
            month: Number(date?.slice(0, 2)),
            year: Number(date?.slice(6))
        };
    }

    return output;
};

/** Section the notifications menu lists an item under. */
export function notificationGroup(date: string): NotificationGroup {
    const target = moment(date);

    if (target.isSame(moment(), 'day')) return 'Today';
    if (target.isSame(moment().subtract(1, 'day'), 'day')) return 'Yesterday';
    if (target.isAfter(moment().subtract(7, 'days'))) return 'Last Week';

    return 'Older';
};

/** "5m" / "17h" / "3d" while the date is recent, a plain date once it is over a week old. */
export function fromNowShort(date: string) {
    const target = moment(date);
    const minutes = moment().diff(target, 'minutes');

    if (minutes < 1) return 'now';
    if (minutes < 60) return `${minutes}m`;

    const hours = moment().diff(target, 'hours');
    if (hours < 24) return `${hours}h`;

    const days = moment().diff(target, 'days');
    if (days < 7) return `${days}d`;

    return target.format('MMMM D, YYYY');
};
